import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vr-main',
  templateUrl: './vr-main.component.html',
  styleUrls: ['./vr-main.component.css'],
})
export class VrMainComponent {
  // assets\img\company\vr-main.png
  constructor(private router: Router) {}
  goToVrPage() {
    this.router.navigateByUrl('/company-admin/virtual-interviews');
  }
}
